export const USER_COLUMNS = [
  { key: 'inactive', label: 'Inactive', color: '#94a3b8' },
  { key: 'regular', label: 'Regular', color: '#60a5fa' },
  { key: 'agent', label: 'Agents', color: '#34d399' },
  { key: 'affiliate', label: 'Affiliates', color: '#f59e0b' }
];
